import { createAction, props } from '@ngrx/store';

import { prefixed } from '@hunting-nature/Secacam/shared/utils/factory.utils';

const liveStream = prefixed('[Live Stream]');

export const LiveStreamActions = {
  // Opening the modal also starts the device stream — the result actions report
  // whether it came up.
  openLiveStream: createAction(liveStream('Open live stream')),
  openLiveStreamSucceeded: createAction(liveStream('Open live stream succeeded')),
  openLiveStreamFailed: createAction(liveStream('Open live stream failed'), props<{ error: string }>()),

  closeLiveStream: createAction(liveStream('Close live stream')),
  closeLiveStreamSucceeded: createAction(liveStream('Close live stream succeeded')),

  // Pause keeps the viewer open but tears the media session down; resume replays the full
  // start sequence — WHEP has no pause, only sessions (see LiveStreamEffects), a failed pause leaves the stream live.
  pauseStream: createAction(liveStream('Pause stream')),
  pauseStreamSucceeded: createAction(liveStream('Pause stream succeeded')),
  pauseStreamFailed: createAction(liveStream('Pause stream failed'), props<{ error: string }>()),

  resumeStream: createAction(liveStream('Resume stream')),
  resumeStreamSucceeded: createAction(liveStream('Resume stream succeeded')),
  resumeStreamFailed: createAction(liveStream('Resume stream failed'), props<{ error: string }>()),

  // Both capture commands follow the intent/succeeded/failed trio: the reducer applies the
  // outcome only from *Succeeded/*Failed (a failed stop must keep the recording UI alive).
  // *Failed opens the blocking error sheet (dismissed via dismissCaptureError); a successful
  // capture sets a transient confirmation badge (dismissed via dismissCaptureConfirmation).
  // recordVideoFailed needs no `recording` flag: the failed operation IS the toggle, so one
  // shared recording message covers both a failed start and a failed stop.
  recordVideo: createAction(liveStream('Record video'), props<{ recording: boolean }>()),
  recordVideoSucceeded: createAction(liveStream('Record video succeeded'), props<{ recording: boolean }>()),
  recordVideoFailed: createAction(liveStream('Record video failed'), props<{ error: string }>()),

  // Leaving the viewer while a recording runs is blocked until the user decides: keep recording
  // (dismiss) or stop the recording and close (handled by the component dispatching both actions).
  showStopRecordingConfirm: createAction(liveStream('Show stop recording confirm')),
  dismissStopRecordingConfirm: createAction(liveStream('Dismiss stop recording confirm')),

  takePicture: createAction(liveStream('Take picture')),
  takePictureSucceeded: createAction(liveStream('Take picture succeeded')),
  takePictureFailed: createAction(liveStream('Take picture failed'), props<{ error: string }>()),

  // Acknowledges the transient capture confirmation badge (screenshot saved / recording saved).
  dismissCaptureConfirmation: createAction(liveStream('Dismiss capture confirmation')),

  // Acknowledges the blocking error sheet opened by recordVideoFailed/takePictureFailed.
  dismissCaptureError: createAction(liveStream('Dismiss capture error')),

  connectionStateChanged: createAction(liveStream('Connection state changed'), props<{ connectionState: string }>()),

  // The connection came up but the device never sent a decodable frame.
  videoTimedOut: createAction(liveStream('Video timed out')),
};
